import { I18n } from '@calendly/i18n'
import { BulletPointListIcon, CalendarIcon } from '@calendly/ui/components/icons'
import { ViewSwitcher as ViewSwitcherComponent } from '@calendly/ui/components/view-switcher'

import { useTrackAvailabilityInteraction } from 'hooks/analytics_events/use_track_availability_interaction'

const trackActions = {
  list: 'view_availability_list',
  calendar: 'view_calendar',
}

export const ViewSwitcher = ({ view, onChange, trackLocation }) => {
  const trackViewSwitch = useTrackAvailabilityInteraction({
    location: trackLocation
  })

  const handleChange = ({ target: { value } }) => {
    if (view !== value) trackViewSwitch({ action: trackActions[value] })
    return onChange(value)
  }

  return (
    <div>
      <ViewSwitcherComponent
        name="availability-view-switcher"
        options={[
          {
            text: I18n.t('publisher.availability_page.default_schedule.header.switcher.list'),
            value: 'list',
            icon: <BulletPointListIcon />
          },
          {
            text: I18n.t('publisher.availability_page.default_schedule.header.switcher.calendar'),
            value: 'calendar',
            icon: <CalendarIcon />
          },
        ]}
        value={view}
        onChange={handleChange}
      />
    </div>
  )
}
